import scenes from '../data';

export default {
  state: {
    lang: localStorage.lang ? localStorage.lang : 'de',
    currentScene: 'home',
    subScene: null,
  },
  getters: {
    currentTitle: (state) => {
      const scene = !state.subScene
        ? scenes.filter((scene) => scene.id === state.currentScene)[0]
        : scenes
            .filter((scene) => scene.id === state.currentScene)[0]
            .subscenes.filter((scene) => scene.id === state.subScene)[0];

      return scene.title;
    },

    currentInformation: (state) => {
      const scene = !state.subScene
        ? scenes.filter((scene) => scene.id === state.currentScene)[0]
        : scenes
            .filter((scene) => scene.id === state.currentScene)[0]
            .subscenes.filter((subscene) => subscene.id === state.subScene)[0];

      return scene.information || false;
    },

    currentSubtitle: (state) => {
      const scene = !state.subScene
        ? scenes.filter((scene) => scene.id === state.currentScene)[0]
        : scenes
            .filter((scene) => scene.id === state.currentScene)[0]
            .subscenes.filter((subscene) => subscene.id === state.subScene)[0];

      return scene.subtitle;
    },
  },
  mutations: {
    setScene(state, payload) {
      if (payload.type === 'sub') {
        state.subScene = payload.scene;
      } else {
        state.subScene = null;
        state.currentScene = payload.scene;
      }
    },
    switchLang(state, payload) {
      localStorage.lang = payload;
      state.lang = payload;
    },
  },
};
